import { render, staticRenderFns } from "./DraftOrders.vue?vue&type=template&id=47f22c2d&scoped=true&"
import script from "./DraftOrders.vue?vue&type=script&lang=js&"
export * from "./DraftOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f22c2d",
  null
  
)

export default component.exports